import { View } from "binder"
import { BankSelectorViewModel } from "src/erp/arap/rawData/bank/bankSelector-viewModel";
import { DistrictSelector } from "src/erp/enterpriseAdministration/districts/districtManipulation/districtSelector";
import { ChequeGatewayViewModel } from "./chequeGateway-viewModel"

export class ChequeGatewayView extends View<ChequeGatewayViewModel>{
    GetViewUniqueId(): string {
        return "V-59B540F2-845C-4F00-828E-D40C7FC9888A"
    }
    loadHtml(): string {
        let element = require('./chequeGateway.html').default;
        let style = require('./chequeGateway.less');
        return element;
    }
    constructor() {
       super();
    }

    public set district(v: DistrictSelector) { this._district = v; } public get district(): DistrictSelector { return this._district;} private _district: DistrictSelector;
    public set bankSelector(v: BankSelectorViewModel) { this._bankSelector = v; } public get bankSelector(): BankSelectorViewModel { return this._bankSelector;} private _bankSelector: BankSelectorViewModel;
    public set chequeSerialNumber(v: string) { this._chequeSerialNumber = v; } public get chequeSerialNumber(): string { return this._chequeSerialNumber;} private _chequeSerialNumber: string;
    public set chequeTime(v: moment.Moment) { this._chequeTime = v; } public get chequeTime(): moment.Moment { return this._chequeTime;} private _chequeTime: moment.Moment;
    public set reason(v: string) { this._reason = v; } public get reason(): string { return this._reason;} private _reason: string;
    public set isForGuarantee(v: boolean) { this._isForGuarantee = v; } public get isForGuarantee(): boolean { return this._isForGuarantee;} private _isForGuarantee: boolean;
    
}
